// extracted by mini-css-extract-plugin
export default {"ctaWrapper":"sY-z","subtitle":"tY-z","wrapper":"uY-z","leftArrow":"vY-z","rightArrow":"wY-z"};